export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10916.f709d504.jpg";